import { useAuth0 } from '@auth0/auth0-react';
import { useMutation } from '@tanstack/react-query';

import { updateBulkOperation } from '../apis/bulkOperationApi';
import { UpdateBulkOperationRequest } from '../apis/types';

import { useInvalidateBulkOperation } from './useInvalidateImport';

export const useBulkOperationMetadata = (bulkOperationId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const { invalidateBulkOperation } =
    useInvalidateBulkOperation(bulkOperationId);

  const updateBulkOperationMutation = useMutation({
    mutationFn: async (request: UpdateBulkOperationRequest) => {
      const token = await getAccessTokenSilently();
      return updateBulkOperation(bulkOperationId, request, token);
    },
    onSuccess: () => {
      invalidateBulkOperation();
    },
  });

  return {
    updateBulkOperation: updateBulkOperationMutation.mutateAsync,
    isUpdating: updateBulkOperationMutation.isPending,
    updateError: updateBulkOperationMutation.error?.message || null,
  };
};
